import { ActionType } from '../../constants/ActionTypes'

export default function gamesReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_GAMES_BEGIN:
            return {
                ...state,
                isGameLoading: true,
                isThereIsMore: true

            }
        case ActionType.GET_GAMES_AND_KEEP_OLD_BEGIN:
            return {
                ...state,
                isGameLoading: true,
                isMoreGameLoading: true,
                isThereIsMore: true

            }
        case ActionType.GET_GAMES_ERROR:
            return {
                ...state,
                isGameLoading: false,
                isMoreGameLoading: false,
                isThereIsMore: true
            }
        case ActionType.GET_GAMES_SUCCESS:
            return {
                ...state,
                isGameLoading: false,
                gameList: action.payload.products,
                isThereIsMore: true

            }
        case ActionType.GET_GAMES_AND_KEEP_OLD_SUCCESS:
            const { count = 0, products = [] } = action.payload
            const gameList = [...state.gameList, ...products];
            const isThereIsMore = products.length && gameList.length !== count ? true : false;

            return {
                ...state,
                isGameLoading: false,
                isMoreGameLoading: false,
                gameList: gameList,
                isThereIsMore: isThereIsMore
            }
        case ActionType.GET_RECENT_GAMES_BEGIN:
            return {
                ...state,
                isRecentLoading: true

            }
        case ActionType.GET_RECENT_GAMES_ERROR:
            return {
                ...state,
                isRecentLoading: false

            }
        case ActionType.GET_RECENT_GAMES_SUCCESS:

            return {
                ...state,
                isRecentLoading: false,
                recentGames: action.payload,

            }
        case ActionType.GET_RANDOM_GAMES_BEGIN:
            return {
                ...state,
                isRandomLoading: true

            }
        case ActionType.GET_RANDOM_GAMES_ERROR:
            return {
                ...state,
                isRandomLoading: false

            }
        case ActionType.GET_RANDOM_GAMES_SUCCESS:

            return {
                ...state,
                isRandomLoading: false,
                randomGames: action.payload,

            }

        case ActionType.GET_TOP_WINNERS_BEGIN:
            return {
                ...state,
                isTopWinnersLoading: true

            }


        case ActionType.GET_TOP_WINNERS_ERROR:
            return {
                ...state,
                isTopWinnersLoading: false

            }
        case ActionType.GET_TOP_WINNERS_SUCCESS:
            return {
                ...state,
                isTopWinnersLoading: false,
                topWinners: { ...state.topWinners, ...action.payload }
            }

        case ActionType.GET_TOP_WINNERS_WIDGET_BEGIN:
            return {
                ...state,
                isTopWinnersLoading: true
            }
        case ActionType.GET_TOP_WINNERS_WIDGET_ERROR:
            return {
                ...state,
                isTopWinnersLoading: false

            }
        case ActionType.GET_TOP_WINNERS_WIDGET_SUCCESS:
            return {
                ...state,
                isTopWinnersLoading: false,
                topWinnersWidget: action.payload
            }
        case ActionType.GET_TOP_JACKPOTS_SUCCESS:

            // const isChanged = (JSON.stringify(state.topJackpots) === JSON.stringify(action.payload))
            // console.log("shallowEqual", isChanged);
            // console.log(state.topJackpots, action.payload);

            // if (isChanged) {
            //     return state; // No change, keep reference
            // }
            return {
                ...state,
                isTopJackpotsLoading: false,
                topJackpots: { ...state.topJackpots, ...action.payload },
                jackpotRecieveDate: new Date().getTime()
            }
        case ActionType.GET_TOP_JACKPOTS_BEGIN:
            return {
                ...state,
                isTopJackpotsLoading: true

            }
        case ActionType.GET_TOP_JACKPOTS_ERROR:
            return {
                ...state,
                isTopJackpotsLoading: false
            }
        case ActionType.SET_RELUM_JACKPOT_SCRIPT_STATE_SUCCESS:
            return {
                ...state,
                relumJackpotSettings: {
                    ...state.relumJackpotSettings,
                    isScriptLoaded: true,
                }
            }
        case ActionType.GET_RELUM_JACKPOT_TOKEN_SUCCESS:
            return {
                ...state,
                relumJackpotSettings: {
                    ...state.relumJackpotSettings,
                    relumToken: action.payload,
                    tokenInProcess: false
                }
            }
        case ActionType.GET_RELUM_JACKPOT_TOKEN_BEGIN:
            return {
                ...state,
                relumJackpotSettings: {
                    ...state.relumJackpotSettings,
                    tokenInProcess: true,
                    token: null
                }
            }
        case ActionType.GET_RELUM_JACKPOT_TOKEN_ERROR:
            return {
                ...state,
                relumJackpotSettings: {
                    ...state.relumJackpotSettings,
                    token: null,
                    tokenInProcess: false
                }
            }


        case ActionType.GET_JACKPOTWIDGET_BEGIN:
            return {
                ...state,
                isJackpotWidgetLoading: true

            }
        case ActionType.GET_JACKPOTWIDGET_ERROR:
            return {
                ...state,
                isJackpotWidgetLoading: false

            }
        case ActionType.GET_JACKPOTWIDGET_SUCCESS:
            return {
                ...state,
                isJackpotWidgetLoading: false,
                jackpotWidget: action.payload,
            }

        case ActionType.GET_GAME_LAUNCH_BEGIN:
            return {
                ...state,
                error: null,
                gameLaunchSuccess: false,
                isLaunchLoading: true
            }
        case ActionType.GET_GAME_LAUNCH_ERROR:
            return {
                ...state,
                error: action.payload,
                isLaunchLoading: false
            }
        case ActionType.GET_GAME_LAUNCH_SUCCESS:
            return {
                ...state,
                isLaunchLoading: false,
                gameLaunchSuccess: true,
                launchGame: action.payload ? action.payload : null,
            }
        case ActionType.SET_SELECTED_GAME_CATEGORY:
            return {
                ...state,
                selectedGameCategory: { ...state.selectedGameCategory, ...action.payload }
            }
        case ActionType.CLEAR_GAMES:
            return {
                ...state,
                gameList: []
            }
        default:
            return state;
    }

}